// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ff-6";
export var emphasizeQuantity = "_ff-3";
export var flatBottomCorners = "_ff-5";
export var productImage = "_ff-0";
export var quantityContainer = "_ff-2";
export var tooltip = "_ff-1";
export var wrapAndEllipsesOverflow = "_ff-4";